import {
  descargarPlantilla, leerLibro, buscarTabla, vacio, texto, sinDato, elegirDeLista,
  normalizarDireccion, momentoDe, leerMomento, ejemplosDirecciones, fechaDeMomento,
} from "./importar_masivo";
import { fechaHoraDart } from "./pase_visitante";
import { generarId } from "./crud";

// Novedades: tipos y campos iguales a la app (models/novedades_modelo.dart y
// widgets/modulo_novedades/crear_novedad.dart), y carga masiva desde Excel o CSV (solo web).

// Mismos valores que listaSitios de la app (sin tilde en SOTANO y SALON SOCIAL).
export const TIPOS_NOVEDAD = [
  "VIVIENDA", "NOTIFICACIÓN", "SEGURIDAD", "ADMINISTRACIÓN", "CONVIVENCIA",
  "CENTRAL DE MONITOREO", "PARQUEADERO", "SOTANO", "BBQ", "CANCHAS", "PISCINA",
  "TURCO", "SALA DE JUNTAS", "SALA DE CAPACITACIONES", "TINTEADERO", "SAUNA",
  "SALON SOCIAL", "ZONA GAMER", "COWORKING", "SALA DE YOGA", "PARQUE MASCOTAS",
  "VOLEIBOL", "JACUZZI", "TENIS", "PESCA", "PING PONG", "MINI GOLF",
];

// Partes del vehículo que revisa la app, con los valores BUENO o MALO.
export const CAMPOS_VEHICULO = [
  { key: "vehiculoEspejos",       label: "Espejos" },
  { key: "vehiculoParabrisas",    label: "Parabrisas" },
  { key: "vehiculoPlumillas",     label: "Plumillas" },
  { key: "vehiculoFarolas",       label: "Farolas" },
  { key: "vehiculoVentanillas",   label: "Ventanillas" },
  { key: "vehiculoDireccionales", label: "Direccionales" },
  { key: "vehiculoBompers",       label: "Bompers" },
  { key: "vehiculoStop",          label: "Stop" },
  { key: "vehiculoRepuestos",     label: "Repuestos" },
  { key: "vehiculoLamina",        label: "Lámina" },
];

// Tipos de novedad en los que la web pide revisar el vehículo.
export const SITIOS_VEHICULO = ["PARQUEADERO", "CONVIVENCIA", "ADMINISTRACIÓN"];

const ESTADOS_PARTE = { BUENO: "BUENO", B: "BUENO", MALO: "MALO", M: "MALO" };

// La app guarda la fecha en "fecha_y_hora" y las fotos en "url_foto1".."url_foto6";
// versiones anteriores de la web usaban "fechayhora" y "urlFoto1". Se leen las dos.
export const fechaNovedad = (n) => n?.fecha_y_hora || n?.fechayhora || "";
export const fotosNovedad = (n) =>
  [1, 2, 3, 4, 5, 6].map(i => n?.[`url_foto${i}`] || n?.[`urlFoto${i}`]).filter(Boolean);

// Torre/manzana y apartamento/casa por separado, como los guarda la app.
export const partesDireccion = (direccion) => {
  const d = String(direccion || "");
  const sector = d.match(/\b(?:TORRE|MANZANA)\s+(\S+)/i);
  const numero = d.match(/\b(?:APARTAMENTO|CASA)\s+(\S+)/i);
  return { torreManzana: sector ? sector[1] : "", apartamentoCasa: numero ? numero[1] : "" };
};

// Novedad con los mismos campos que guarda la app. fecha: Date; fotos: lista de enlaces (hasta 6).
export const nuevaNovedad = ({ fecha, tipo, descripcion, direccion, placa, usuario, fotos = [], vehiculo = {} }) => ({
  fecha_y_hora: fechaHoraDart(fecha),
  tipoZona: tipo,
  nit: localStorage.getItem("CodigoCliente") || "",
  razonSocial: localStorage.getItem("RazonSocial") || "",
  usuario: usuario || localStorage.getItem("NombreCompleto") || "",
  permiso: localStorage.getItem("Permisos") || "",
  descripcion_novedad: descripcion,
  placa: placa || null,
  direccion: direccion || null,
  ...partesDireccion(direccion),
  ...Object.fromEntries([1, 2, 3, 4, 5, 6].map(i => [`url_foto${i}`, fotos[i - 1] || ""])),
  ...vehiculo,
});

// Carpeta del mes en que ocurrió la novedad (igual que la app).
export const rutaNovedades = (nit, fecha) =>
  `coordi_ph/${nit}/novedad/${fecha.getFullYear()}/${String(fecha.getMonth() + 1).padStart(2, "0")}`;

const SIN_VEHICULO = CAMPOS_VEHICULO.map(() => "");

export const COLUMNAS_PLANTILLA = [
  "FECHA", "CLIENTE", "USUARIO", "TIPO DE NOVEDAD", "DESCRIPCIÓN", "PLACA",
  ...CAMPOS_VEHICULO.map(c => c.label.toUpperCase()),
];

export const EJEMPLOS_PLANTILLA = [
  ["07/10/2026 22:15", "", "RECEPCIÓN", "CONVIVENCIA", "Ruido excesivo después de las 10 p. m.", "", ...SIN_VEHICULO],
  ["08/10/2026 07:40", "", "RONDA", "PARQUEADERO", "Parqueadero 12: bomper delantero rayado", "ABC123",
    "BUENO", "BUENO", "BUENO", "BUENO", "BUENO", "BUENO", "MALO", "BUENO", "BUENO", "BUENO"],
  ["", "", "", "SEGURIDAD", "Puerta peatonal quedó abierta durante la ronda", "", ...SIN_VEHICULO],
];

export const descargarPlantillaNovedades = () => descargarPlantilla({
  archivo: "plantilla_novedades.xlsx",
  hoja: "Novedades",
  columnas: COLUMNAS_PLANTILLA,
  ejemplos: EJEMPLOS_PLANTILLA,
  anchos: [18, 14, 18, 20, 44, 10, ...CAMPOS_VEHICULO.map(() => 13)],
  instrucciones: [
    ["FECHA", "No", "Día y hora de la novedad, como 07/10/2026 22:15 (día/mes/año y hora de 24 horas). Si la deja vacía se usa la fecha y hora de la carga."],
    ["CLIENTE", "No", "Puede dejarla vacía: la novedad siempre queda en el conjunto con el que inició sesión."],
    ["USUARIO", "No", "Quién reporta la novedad. Si la deja vacía se usa el nombre de quien hace la carga."],
    ["TIPO DE NOVEDAD", "Sí", TIPOS_NOVEDAD.join(", ") + "."],
    ["DESCRIPCIÓN", "Sí", "Qué pasó, con el mayor detalle posible."],
    ["PLACA", "No", "Placa del vehículo relacionado, como ABC123."],
    ...CAMPOS_VEHICULO.map(c => [c.label.toUpperCase(), "No",
      "Solo si revisó un vehículo: BUENO o MALO (también sirve B o M). Si llena alguna de estas columnas, las vacías quedan BUENO."]),
  ],
});

// El orden importa: la primera regla que coincide decide el campo.
const REGLAS_COLUMNAS = [
  ["vehiculoEspejos",       /\b(espejos?|retrovisor(es)?)\b/],
  ["vehiculoParabrisas",    /\bparabrisas\b/],
  ["vehiculoPlumillas",     /\bplumillas?\b/],
  ["vehiculoFarolas",       /\bfarolas?\b/],
  ["vehiculoVentanillas",   /\bventanillas?\b/],
  ["vehiculoDireccionales", /\bdireccionales?\b/],
  ["vehiculoBompers",       /\bbompers?\b/],
  ["vehiculoStop",          /\bstops?\b/],
  ["vehiculoRepuestos",     /\brepuestos?\b/],
  ["vehiculoLamina",        /\blaminas?\b/],
  ["fecha",       /\b(fecha|hora)\b/],
  ["descripcion", /\b(descripcion|detalle|observacion|observaciones)\b/],
  ["tipo",        /\b(tipo|novedad|zona|sitio|categoria)\b/],
  ["usuario",     /\b(usuario|reporta|reportado|registrado|guarda|portero)\b/],
  ["cliente",     /\b(cliente|conjunto|copropiedad)\b/],
  ["placa",       /\bplacas?\b/],
  ["foto",        /\b(foto|fotos|imagen|url)\b/],
  ["vivienda",    /\b(direccion|vivienda|inmueble|apartamento|apto|casa|unidad)\b/],
];

const esEncabezado = (c) => c.tipo !== undefined && c.descripcion !== undefined;

// ahora: fecha y hora de la carga. Devuelve { encontroEncabezado, registros, errores, ejemplos }.
// Cada registro: { fila, original, vivienda, usuario, tipo, descripcion, placa, foto, vehiculo, fecha, hora }.
export const leerLibroNovedades = (libro, ahora = new Date()) => {
  const tabla = buscarTabla(libro, REGLAS_COLUMNAS, esEncabezado);
  if (!tabla) return { encontroEncabezado: false, registros: [], errores: [], ejemplos: [] };

  const actual = momentoDe(ahora);
  const { filas, indice, columnas } = tabla;
  const celda = (fila, campo) => (columnas[campo] !== undefined ? fila[columnas[campo]] : "");
  const registros = [];
  const errores = [];

  filas.slice(indice + 1).forEach((fila, i) => {
    const numeroFila = indice + i + 2;
    if (fila.every(vacio)) return;

    const valorTipo = texto(celda(fila, "tipo"));
    const descripcion = String(celda(fila, "descripcion")).trim();
    const original = sinDato(celda(fila, "vivienda")) ? "" : texto(celda(fila, "vivienda"));
    const usuario = texto(celda(fila, "usuario"));
    const placa = sinDato(celda(fila, "placa")) ? "" : texto(celda(fila, "placa")).toUpperCase().replace(/[^A-Z0-9]/g, "");
    const foto = texto(celda(fila, "foto"));

    const problemas = [];
    const faltan = [];
    if (!valorTipo) faltan.push("el tipo de novedad");
    if (!descripcion) faltan.push("la descripción");
    if (faltan.length) problemas.push(`falta ${faltan.join(", ")}`);

    const tipo = valorTipo ? elegirDeLista(valorTipo, TIPOS_NOVEDAD) : null;
    if (valorTipo && !tipo) problemas.push(`el tipo de novedad "${valorTipo}" no existe; revise la hoja Instrucciones`);
    if (foto && !/^https?:\/\//i.test(foto)) problemas.push("la foto debe ser un enlace que empiece por http; si no tiene, deje la columna vacía");

    // Si la fila trae alguna parte del vehículo, se guardan todas (las vacías quedan BUENO, como en la app).
    const vehiculo = {};
    const partes = CAMPOS_VEHICULO.map(c => ({ ...c, valor: texto(celda(fila, c.key)).toUpperCase() }));
    if (partes.some(p => p.valor)) {
      partes.forEach(({ key, label, valor }) => {
        const estado = valor ? ESTADOS_PARTE[valor] : "BUENO";
        if (estado) vehiculo[key] = estado;
        else problemas.push(`${label} dice "${valor}"; escriba BUENO o MALO`);
      });
    }

    const leida = leerMomento(celda(fila, "fecha"), "", "de la novedad", problemas);
    const momento = leida ? { fecha: leida.fecha, hora: leida.hora || "00:00" } : actual;
    if (`${momento.fecha} ${momento.hora}` > `${actual.fecha} ${actual.hora}`) problemas.push("la fecha es posterior a hoy");

    if (problemas.length) {
      errores.push({ fila: numeroFila, texto: problemas.join("; ") });
      return;
    }

    registros.push({
      fila: numeroFila,
      original,
      vivienda: original ? normalizarDireccion(original) : "",
      usuario,
      tipo,
      descripcion,
      placa,
      foto,
      vehiculo,
      fecha: momento.fecha,
      hora: momento.hora,
    });
  });

  return {
    encontroEncabezado: true,
    registros,
    errores,
    ejemplos: ejemplosDirecciones(registros.filter(r => r.vivienda)),
  };
};

export const leerArchivoNovedades = async (archivo, ahora = new Date()) =>
  leerLibroNovedades(await leerLibro(archivo), ahora);

// ---------- Guardado ----------

export const cambiosNovedadCargada = (r, i, { nit, usuario }) => {
  const fecha = fechaDeMomento(r, i);
  const ruta = rutaNovedades(nit, fecha);
  return {
    [`${ruta}/${generarId(ruta)}`]: nuevaNovedad({
      fecha,
      tipo: r.tipo,
      descripcion: r.descripcion,
      direccion: r.vivienda,
      placa: r.placa,
      usuario: r.usuario || usuario,
      fotos: r.foto ? [r.foto] : [],
      vehiculo: r.vehiculo,
    }),
  };
};
